module.exports = __webpack_public_path__ + "static/media/circle-view-on.df5d43b9.svg";